import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

const script = document.currentScript;
const url = new URL(script.src);

const components = {
  Balancer: React.lazy(() => import('./Balancer/Balancer')),
  CAGR: React.lazy(() => import('./CAGR/CAGR')),
  Timezone: React.lazy(() => import('./Timezone/Timezone')),
  ReactInputNumberFormatting: React.lazy(() => import('./ReactInputNumberFormatting'))
};

function ComponentRenderer () {
  const componentName = url.searchParams.get('component') || '';
  const Component = components[componentName];

  if (typeof Component === 'undefined') {
    throw new Error(`No component with name "${componentName}" registered`);
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Component searchParams={url.searchParams} />
    </Suspense>
  )
}

(() => {
  const targetElementId = url.searchParams.get('target') || 'root';
  const container = document.getElementById(targetElementId);
  if (container) {
    const root = createRoot(container);
    root.render(<ComponentRenderer />);
  } else {
    throw new Error(`No element with ID "${targetElementId}"`);
  }
})();
